import React from 'react';
import { SmallTitle } from './style';

const SmallTitleComponent = props => {
  const { children, className } = props;
  return (
    <SmallTitle
      className={`${className !== undefined ? className : ''}`}
    > 
      {children}
    </SmallTitle>
  )
};

export default SmallTitleComponent;